import React from "react"
import PropTypes from "prop-types"

const AdminAction = ({ path, icon = undefined, label }) => {
  const iconElement = icon ? <i className={`icon-${icon}`} /> : null

  return (
    <li key={path}>
      <a href={path}>
        {iconElement}
        {label}
      </a>
    </li>
  )
}

AdminAction.propTypes = {
  path: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.string,
}

export default AdminAction
